import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import KiloNewton from "../../../../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function KnicklastDesErsatzstabes({ knicklastDesErsatzstabes = 0 }) {
  const { t } = useTranslation("translation");
  const quer_N_ki_Formula = `\\displaystyle \\overline{N}_{ki} = \\frac{\\pi^2 \\cdot EI_{s}}{L_{\\small{Hw}^2}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.bucklingLoadEquivalentBar")}</p>}
      indicesValue={
        <>
          <span style={{ textDecoration: "overline" }}>N</span>
          <span>
            <sub>ki</sub>
          </span>
        </>
      }
      formulaValue={
        <ToolTip id={"quer_N_ki_Formula"} type={IconType.FORMULA} formula={quer_N_ki_Formula} />
      }
      inputValue={<span className="input">{ConvertToString(knicklastDesErsatzstabes, 0)}</span>}
      unitValue={<KiloNewton />}
    />
  );
}

export default KnicklastDesErsatzstabes;
